<template>
    <div class="menu-trigger" @click="toggleMenu" :class="{open: menuOpen}">
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script>
    import { faTimes }  from '@fortawesome/pro-regular-svg-icons/faTimes'
    import { faBars }  from '@fortawesome/pro-regular-svg-icons/faBars'

    export default {
        name: "MobileMenuButton",
        props: {
            menuOpen: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            menuIcon() {
                return this.menuOpen ? faTimes : faBars
            }
        },
        methods: {
            toggleMenu() {
                this.$emit('toggleMenu')
            }
        }
    }
</script>

<style lang="scss" scoped>

    .menu-trigger {
        z-index: 999;
        margin-left: 20px;
        width: 65px;
        height: 66px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $color1;
        background-color: $color3;
        font-size: 21px;
        position: relative;

        span{
            position: absolute;
            height: 2px;
            width: 22px;
            background-color: $color1;
            left: 0;
            right: 0;
            margin: auto;
            top: 50%;
            transition: all .3s ease-in-out;

            &:first-child{
                top: calc(50% - 8px);
            }

            &:last-child{
                top: calc(50% + 8px);
            }
        }


        &.open {
            span{
                opacity: 0;
                top: 50%;

                &:first-child {
                    transform: rotate(45deg);
                    opacity: 1;
                }

                &:last-child {
                    transform: rotate(-45deg);
                    opacity: 1;
                }
            }
        }
    }

</style>